import { ref, type Ref } from 'vue';
import type { RuntimeConfig } from '@/types';
import { statusMessages } from '@/i18n';

const DEFAULT_CONFIG: RuntimeConfig = {
  statusUrl: 'status.json',
  historyUrlPrefix: 'history',
  refreshIntervalMs: 30000,
  uptimeWindowDays: 90,
  brand: {
    name: 'Cogneris',
    tagline: statusMessages.platformStatus,
  },
};

const config: Ref<RuntimeConfig> = ref(DEFAULT_CONFIG);
let loaded = false;

export async function loadConfig(): Promise<RuntimeConfig> {
  if (loaded) return config.value;
  try {
    const response = await fetch('config.json', { cache: 'no-store' });
    if (response.ok) {
      config.value = { ...DEFAULT_CONFIG, ...(await response.json()) };
    }
  } catch {
    // fall back to defaults
  }
  loaded = true;
  return config.value;
}

export function useConfig(): Ref<RuntimeConfig> {
  return config;
}
